import { useLocation } from 'react-router-dom';
import { Tab, Tabs } from '@hopskipdrive/react-components';

import { actions, subjects, useAbility } from '../../../contexts/AbilityContext';
import { useFlags } from '../../../contexts/LDContext';
import { useNavigation } from '../../../shared/hooks/useNavigation';

import { getCurrentTab, ReportsTab } from './getCurrentTab';

const routeByTab: Record<ReportsTab, string> = {
  rides: '/reports',
  riders: '/reports/riders',
  report_history: '/reports/history',
};

export const ReportsTabs = () => {
  const { navigateTo } = useNavigation();
  const { pathname } = useLocation();
  const ability = useAbility();
  const { rideiqRiderSummaryReportEnabled } = useFlags();
  const currentTab = getCurrentTab(pathname);

  const showRiderSummaryTabs = rideiqRiderSummaryReportEnabled && ability.can(actions.all, subjects.clientReport);

  // MUI skips onChange for the selected tab; reactivation must still reset saved-report URLs.
  return (
    <Tabs
      value={currentTab}
      aria-label="Reports"
      showIndicator
      variant="scrollable"
      scrollButtons="auto"
      onChange={(_, value: ReportsTab) => navigateTo(routeByTab[value])}
      data-testid="reports-tabs-nav"
    >
      <Tab label="Rides Report" value="rides" onClick={() => currentTab === 'rides' && navigateTo('/reports')} />
      {showRiderSummaryTabs && (
        <Tab
          label="Rider Summary"
          value="riders"
          onClick={() => currentTab === 'riders' && navigateTo('/reports/riders')}
        />
      )}
      {showRiderSummaryTabs && (
        <Tab
          label="Report History"
          value="report_history"
          onClick={() => currentTab === 'report_history' && navigateTo('/reports/history')}
        />
      )}
    </Tabs>
  );
};
